import React, { useEffect, useState } from 'react';
interface ToggleSwitchProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  storageKey?: string;
  defaultChecked?: boolean;
}
export function ToggleSwitch({
  value,
  onChange,
  label,
  storageKey,
  defaultChecked = false
}: ToggleSwitchProps) {
  // Initialize state from storage if key provided, otherwise use value or default
  const [isToggled, setIsToggled] = useState(() => {
    if (value !== undefined) return value;
    if (storageKey) {
      const stored = localStorage.getItem(storageKey);
      if (stored !== null) return stored === 'true';
    }
    return defaultChecked;
  });
  // Sync with external value if provided
  useEffect(() => {
    if (value !== undefined) {
      setIsToggled(value);
    }
  }, [value]);
  const handleToggle = () => {
    const newValue = !isToggled;
    setIsToggled(newValue);
    if (storageKey) {
      localStorage.setItem(storageKey, String(newValue));
    }
    if (onChange) {
      onChange(newValue);
    }
  };
  return <button type="button" role="switch" aria-checked={isToggled} aria-label={label} onClick={handleToggle} className={`relative inline-flex h-[24px] w-[44px] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-75 ${isToggled ? 'bg-primary' : 'bg-border'}`} data-id="element-323" data-mp="2vo6e35xe6ery">
      <span className="sr-only" data-id="element-324" data-mp="2gpce5ioxvrjd">{label || 'Toggle'}</span>
      <span aria-hidden="true" className={`pointer-events-none inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow ring-0 transition duration-300 ease-in-out ${isToggled ? 'translate-x-[20px]' : 'translate-x-0'}`} data-id="element-325" data-mp="2gqvt95yuzwjk" />
    </button>;
}